import type { EventStreamConfig, StreamSourceKind } from "@tih/shared";

export type StreamForm = {
  kind: StreamSourceKind;
  src: string;
  subtitle: string;
};

export const EMPTY_STREAM_FORM: StreamForm = {
  kind: "youtube",
  src: "",
  subtitle: "",
};

export function streamToForm(stream: EventStreamConfig | null): StreamForm {
  if (!stream) return { ...EMPTY_STREAM_FORM };
  if (stream.source?.src) {
    return {
      kind: stream.source.kind,
      src: stream.source.src,
      subtitle: stream.subtitle ?? "",
    };
  }
  if (stream.youtubeId) {
    return {
      kind: "youtube",
      src: stream.youtubeId,
      subtitle: stream.subtitle ?? "",
    };
  }
  return { ...EMPTY_STREAM_FORM };
}

export function formToStream(form: StreamForm): EventStreamConfig | null {
  const src = form.src.trim();
  if (!src) return null;
  const subtitle = form.subtitle.trim() || null;
  if (form.kind === "youtube") {
    return { youtubeId: src, source: { kind: "youtube", src, poster: null }, subtitle };
  }
  return {
    source: { kind: form.kind, src, poster: null },
    youtubeId: null,
    subtitle,
  };
}

export function streamPlaceholder(kind: StreamSourceKind): string {
  if (kind === "youtube") return "YouTube video id (e.g. 2Z4UlpSdAHE)";
  if (kind === "hls") return "https://…/index.m3u8";
  return "https://…/video.mp4";
}
